import React from "react";
import ReactDOM from "react-dom";
import { ensureBrowserSession } from './_lib/browserSession';
// import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

ensureBrowserSession().finally(() => {
  ReactDOM.render(<App />, document.getElementById("root"));
  registerServiceWorker();
});
